import { action, createRequestTypes } from './base';

export const activityLogActionTypes = {
  GET_ACTIVITY_LOG: createRequestTypes('GET_ACTIVITY_LOG'),
  ADD_ACTIVITY_LOG: createRequestTypes('ADD_ACTIVITY_LOG'),
  EDIT_ACTIVITY_LOG: createRequestTypes('EDIT_ACTIVITY_LOG'),
  GET_HISTORY_LOG_MESSAGE: createRequestTypes('GET_HISTORY_LOG_MESSAGE'),

};

/**
 * ActivityLogActions class
 */
class ActivityLogActions {
    /**
     *
     * @param entityId
     * @param entityName
     * @param page
     * @param limit
     * @returns {{type: *}}
     */
    getActivityLog = (entityId, entityName, page, limit, callback,subEntityId) => action(activityLogActionTypes.GET_ACTIVITY_LOG.REQUEST, {
      entityId, entityName, page, limit, callback,subEntityId
    });

    /**
     *
     * @param getActivityLogLoading
     * @returns {{type: *}}
     */
    getActivityLogLoading = (getActivityLogLoading, entityName) => action(activityLogActionTypes.GET_ACTIVITY_LOG.LOADING, {
      getActivityLogLoading,
      entityName,
    });

    /**
     *
     * @param activityLogSuccess
     * @returns {{type: *}}
     */
    getActivityLogSuccess = (activityLog, entityName) => action(activityLogActionTypes.GET_ACTIVITY_LOG.SUCCESS, {
      activityLog,
      entityName,
    });

    /**
     *
     * @param payload
     * @param callback
     * @returns {{type: *}}
     */
    addActivityLog = (payload, callback) => action(activityLogActionTypes.ADD_ACTIVITY_LOG.REQUEST, {
      payload, callback,
    })

    /**
     *
     * @param addActivityLogLoading
     * @returns {{type: *}}
     */
    addActivityLogLoading = (addActivityLogLoading) => action(activityLogActionTypes.ADD_ACTIVITY_LOG.LOADING, {
      addActivityLogLoading,
    })

    editActivityLogLoading = (editActivityLogLoading) => action(activityLogActionTypes.EDIT_ACTIVITY_LOG.LOADING, {
      editActivityLogLoading,
    })

    editActivityLog = (payload, callback) => action(activityLogActionTypes.EDIT_ACTIVITY_LOG.REQUEST, {
      payload, callback,
    })

    getHistoryActivityLog = (payload, callback) => action(activityLogActionTypes.GET_HISTORY_LOG_MESSAGE.REQUEST, {
      payload, callback,
    })

    getHistoryActivityLogLoading = (getHistoryActivityLogLoading) => action(activityLogActionTypes.GET_HISTORY_LOG_MESSAGE.LOADING, {
      getHistoryActivityLogLoading,
    })

    getHistoryActivityLogSuccess = (activityLogHistoryComments) => action(activityLogActionTypes.GET_HISTORY_LOG_MESSAGE.SUCCESS, {
      activityLogHistoryComments,
    })
}

export default new ActivityLogActions();
